import {Component, OnInit} from '@angular/core';
import {
  Router,
  RoutesRecognized,
} from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { filter, pairwise } from 'rxjs/operators';

@Component({
  selector: 'sam-frontend-admin-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {

  constructor(
    private meta: Meta,
    private router: Router,
    public TemplatePageTitleStrategy: Title
  ) {
    this.meta.addTags([
      { name: 'robots', content: 'index,follow' },
      { name: 'googlebot', content: 'noarchive' },
      {
        name: 'description',
        content:
          'SAM.gov The System for Award Management (SAM) is the Official U.S. Government system that consolidated the capabilities of CCR/FedReg, ORCA, and EPLS',
      },
      {
        name: 'keywords',
        content:
          'SAM.gov,SAM, sam, System for Award Management, Official U.S. Government system, Award, award, news,CCR,FedReg,ORCA, EPLS,Gov awards',
      },
    ]);
  }

  ngOnInit() {
    this.googleAnalyticsScript();
  }

  private googleAnalyticsScript() {
    this.router.events
      .pipe(
        filter((evt: any) => evt instanceof RoutesRecognized),
        pairwise()
      )
      .subscribe((events: RoutesRecognized[]) => {
        try {
          (<any>window).gas(
            'send',
            'pageview',
            events[1].urlAfterRedirects,
            events[0].urlAfterRedirects
          );
        } catch (e) {
          console.error('Blocked by client');
        }
      });
  }

}
